module.exports = __webpack_public_path__ + "static/media/intro-en-fr.ef8e829d.vtt";